/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * PaymentGatewayProxy.Api | v1
 * OpenAPI spec version: 1.0.0
 */

export type WebhookDeliveryStatus = typeof WebhookDeliveryStatus[keyof typeof WebhookDeliveryStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WebhookDeliveryStatus = {
  Pending: 'Pending',
  Delivering: 'Delivering',
  Delivered: 'Delivered',
  Failed: 'Failed',
  Abandoned: 'Abandoned',
} as const;
